// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  padding: 40px 20px 20px;
  position: relative;
  text-align: center;
  text-transform: uppercase;
}
.wrapper .cross-icon {
  z-index: 5;
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.wrapper .cross-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
  cursor: pointer;
}
.wrapper ion-img {
  height: 70px;
  margin-bottom: 20px;
}
.wrapper h3 {
  padding: 15px;
}
.wrapper p {
  padding: 10px;
}
.wrapper ion-input {
  border: 1px solid var(--color-black);
  border-radius: 26px;
  margin-bottom: 20px;
}
.wrapper ion-button {
  width: 100%;
  --border-radius: 300px;
}

.error-message {
  color: #b30101;
  padding: 10px;
  font-size: 12px;
}

.wrapper_for_types {
  height: 42px;
  width: 70%;
  background: var(--default-background);
  border-radius: var(--border-radius-default);
  padding: 10px;
  margin: 0 auto 27px;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.wrapper_for_types .item {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  transition: color 1s ease-in-out;
}
.wrapper_for_types .item p {
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 20.2px;
  letter-spacing: 0.02em;
  text-align: center;
  text-transform: uppercase;
  color: var(--color-black-alt);
  position: relative;
  z-index: 1;
}
.wrapper_for_types .item.active p,
.wrapper_for_types .item.active span {
  color: var(--color-white);
}
.wrapper_for_types .selector {
  position: absolute;
  left: 3%;
  top: 50%;
  width: 49%;
  height: 96%;
  transform: translate(-5%, -50%);
  border-radius: var(--border-radius-default);
  background: var(--ion-color-primary);
  transition: left 0.5s ease-in-out;
}
.wrapper_for_types .selector.second-position {
  left: 55%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/loyalty-components/add-gift-card-dialog/add-gift-card-dialog.component.scss"],"names":[],"mappings":"AAAA;EACC,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AACD;AAAC;EACC,UAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAEF;AADE;EACC,WAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AAGH;AAAC;EACC,YAAA;EACA,mBAAA;AAEF;AAAC;EACC,aAAA;AAEF;AAAC;EACC,aAAA;AAEF;AAAC;EACC,oCAAA;EACA,mBAAA;EACA,mBAAA;AAEF;AAAC;EACC,WAAA;EACA,sBAAA;AAEF;;AACA;EACC,cAAA;EACA,aAAA;EACA,eAAA;AAED;;AAAA;EACC,YAAA;EACA,UAAA;EACA,qCAAA;EACA,2CAAA;EACA,aAAA;EACA,mBAAA;EAEA,aAAA;EACA,8BAAA;EACA,kBAAA;AAED;AAAC;EACC,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gCAAA;AAEF;AADE;EACC,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,UAAA;AAGH;AAAG;;EAEC,yBAAA;AAEJ;AAGC;EACC,kBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EAEA,+BAAA;EACA,2CAAA;EACA,oCAAA;EACA,iCAAA;AAFF;AAIE;EACC,SAAA;AAFH","sourcesContent":[".wrapper {\n\tpadding: 40px 20px 20px;\n\tposition: relative;\n\ttext-align: center;\n\ttext-transform: uppercase;\n\t.cross-icon {\n\t\tz-index: 5;\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\tmargin: 0px;\n\t\tbackground: var(--color-white-accent);\n\t\twidth: 35px;\n\t\theight: 35px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\t\tion-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmargin: 0px;\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n\tion-img {\n\t\theight: 70px;\n\t\tmargin-bottom: 20px;\n\t}\n\th3 {\n\t\tpadding: 15px;\n\t}\n\tp {\n\t\tpadding: 10px;\n\t}\n\tion-input {\n\t\tborder: 1px solid var(--color-black);\n\t\tborder-radius: 26px;\n\t\tmargin-bottom: 20px;\n\t}\n\tion-button {\n\t\twidth: 100%;\n\t\t--border-radius: 300px;\n\t}\n}\n.error-message {\n\tcolor: #b30101;\n\tpadding: 10px;\n\tfont-size: 12px;\n}\n.wrapper_for_types {\n\theight: 42px;\n\twidth: 70%;\n\tbackground: var(--default-background);\n\tborder-radius: var(--border-radius-default);\n\tpadding: 10px;\n\tmargin: 0 auto 27px;\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tposition: relative;\n\n\t.item {\n\t\twidth: 50%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tcursor: pointer;\n\t\tposition: relative;\n\t\ttransition: color 1s ease-in-out;\n\t\tp {\n\t\t\tfont-family: AppFontMedium;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 20.2px;\n\t\t\tletter-spacing: 0.02em;\n\t\t\ttext-align: center;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: var(--color-black-alt);\n\t\t\tposition: relative;\n\t\t\tz-index: 1;\n\t\t}\n\t\t&.active {\n\t\t\tp,\n\t\t\tspan {\n\t\t\t\tcolor: var(--color-white);\n\t\t\t}\n\t\t}\n\t}\n\n\t.selector {\n\t\tposition: absolute;\n\t\tleft: 3%;\n\t\ttop: 50%;\n\t\twidth: 49%;\n\t\theight: 96%;\n\n\t\ttransform: translate(-5%, -50%);\n\t\tborder-radius: var(--border-radius-default);\n\t\tbackground: var(--ion-color-primary);\n\t\ttransition: left 0.5s ease-in-out;\n\n\t\t&.second-position {\n\t\t\tleft: 55%;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
